import { useQuery } from '@tanstack/react-query';
import { projectsApi } from '../services/api';

export const useProjects = (isAdmin = false, enabled = true) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const useEnabled = enabled && (isAdmin || !!token);
  // Инициализация запроса проектов
  const { data, isLoading, error } = useQuery({
    queryKey: ['projects', isAdmin],
    queryFn: isAdmin ? projectsApi.getAll : projectsApi.getUserProjects,
    enabled: useEnabled,
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 30,
  });
  return {
    projects: data?.data || [],
    isLoading,
    error,
  };
};
